import { BodyPix } from '@tensorflow-models/body-pix';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { initialStateModel } from '../../../../base/models/meetModal';
import { buildCanvas2dPipeline } from '../../pipelines/canvas2d/canvas2dPipeline';
import { buildWebGL2Pipeline } from '../../pipelines/webgl2/webgl2Pipeline';
import { BackgroundConfig } from '../helpers/backgroundHelper';
import { RenderingPipeline } from '../helpers/renderingPipelineHelper';
import { SegmentationConfig } from '../helpers/segmentationHelper';
import { SourcePlayback } from '../helpers/sourceHelper';
import { TFLite } from './useTFLite';

export default function  useRenderingPipeline(
  sourcePlayback: SourcePlayback,
  backgroundConfig: BackgroundConfig,
  segmentationConfig: SegmentationConfig,
  bodyPix: BodyPix,
  tflite: TFLite
) {
  const [pipeline, setPipeline] = useState<RenderingPipeline | null>(null);
  const backgroundImageRef = useRef<HTMLImageElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null!);
  const [fps, setFps] = useState(0);
  const [renderID, setRenderID] = useState(0);
  const [shouldRenders, setshouldRender] = useState<boolean>(true);
  const [durations, setDurations] = useState<number[]>([]);
  const [imageIndex, setImageIndex] = useState<number>(0);
  const virtualBGState:{image:any,imgIndex: number,viewMode:string} =
  useSelector((state:initialStateModel) => state.VirtualBG);

  useEffect(() => {
    // The useEffect cleanup function is not enough to stop
    // the rendering loop when the framerate is low
    let renderRequestId: number = 0;
    let previousTime = 0;
    let beginTime = 0;
    let eventCount = 0;
    let frameCount = 0;
    const frameDurations: number[] = [];
    const beginFrame = () => {
      beginTime = Date.now();
    };

    const addFrameEvent = () => {
      const time = Date.now();
      frameDurations[eventCount] = time - beginTime;
      beginTime = time;
      eventCount++;
    };

    const endFrame = () => {
      const time = Date.now();
      frameDurations[eventCount] = time - beginTime;
      frameCount++;
      if (time >= previousTime + 1000) {
        setFps((frameCount * 1000) / (time - previousTime));
        setDurations(frameDurations);
        previousTime = time;
        frameCount = 0;
      }
      eventCount = 0;
    };

    console.log("segmentationConfig.pipeline check",segmentationConfig.pipeline);

    const newPipeline =
        segmentationConfig.pipeline === 'webgl2'
          ? buildWebGL2Pipeline(
            sourcePlayback,
            backgroundImageRef?.current,
            backgroundConfig,
            segmentationConfig,
            canvasRef.current,
            tflite,
            addFrameEvent
          )
          : buildCanvas2dPipeline(
            sourcePlayback,
            backgroundConfig,
            segmentationConfig,
            canvasRef.current,
            bodyPix,
            tflite,
            addFrameEvent
          );

    const  render = async() => {
      if (!shouldRenders) {
        return;
      }
      beginFrame();
      await newPipeline.render();
      endFrame();
      renderRequestId = setTimeout(render);
      setRenderID(renderRequestId);
      setshouldRender(true);
        
    };

    const code = `var timer;
    onmessage = function(request){
      switch (request.data.id){
        case 1:{
          timer = setTimeout(()=>postMessage({id:3}),request.data.timeMs)
          break;
        }
        case 2:{
          if(timer){
            clearTimeout(timer);
          }
          break;
        }
      }
    }`;
    let timeWorkerScript: any = URL.createObjectURL(new Blob([code], { type: 'application/javascript' }));
    let _maskFrameTimeWorker = new Worker(timeWorkerScript, { name: "Blur Effect Worker" });

    _maskFrameTimeWorker.onmessage = async(response: any) =>{
      console.log("response---->", response);
    };

    render();
    console.log(
      'Animation started:',
      sourcePlayback,
      backgroundConfig,
      segmentationConfig
    );

    setPipeline(newPipeline);
    //setMount(true);
    setImageIndex((prevState:number)=>{
      if(prevState!==virtualBGState.imgIndex){
        return virtualBGState.imgIndex;
      } else {
        return prevState;
      }
    });

    return () => {
      clearTimeout(renderRequestId);
      newPipeline.cleanUp();
      //setMount(false);
      console.log(
        imageIndex,'Animation stopped:',
        sourcePlayback,
        backgroundConfig,
        segmentationConfig
      );

      setPipeline(null);

    };

  }, [virtualBGState.imgIndex, virtualBGState.viewMode]);

  return {
    pipeline,
    backgroundImageRef,
    canvasRef,
    fps,
    durations,
    renderID
  };
};
